var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.362,
    height: 18.361,
    viewBox: "0 0 18.362 18.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6419",
    "data-name": "Groupe 6419",
    transform: "translate(-1204.929 -840.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_699",
    "data-name": "Trac\\xE9 699",
    d: "M7275.97,9990.289a2.314,2.314,0,0,1-1.643-.68l-13.717-13.719a2.322,2.322,0,0,1,3.283-3.283l13.717,13.719a2.321,2.321,0,0,1-1.641,3.963Z",
    transform: "translate(-6055 -9131)",
    fill: "#4188f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_700",
    "data-name": "Trac\\xE9 700",
    d: "M16.041,18.361a2.314,2.314,0,0,1-1.643-.68L.682,3.963A2.322,2.322,0,0,1,3.965.68L17.682,14.4a2.321,2.321,0,0,1-1.641,3.963Z",
    transform: "translate(1223.292 840.928) rotate(90)",
    fill: "#4188f2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFile);
export default __webpack_public_path__ + "static/media/delete-file.75042610249a2a218fe30e98be2d40dd.svg";
export { ForwardRef as ReactComponent };